import React, { useState, useEffect } from "react";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../data/content";
import { FadeUp } from "./Motion";

const Testimonials = () => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % TESTIMONIALS.length), 7000);
    return () => clearInterval(t);
  }, []);

  const t = TESTIMONIALS[i];

  return (
    <section data-testid="testimonials" className="py-24 md:py-32 bg-cream-2">
      <div className="container mx-auto px-6 md:px-10 xl:px-16">
        <FadeUp className="max-w-3xl mb-16">
          <p className="eyebrow text-forest">What Partners Say</p>
          <h2 className="mt-4 font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight text-forest">
            Trusted by chefs, spice houses and veterinary experts.
          </h2>
        </FadeUp>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <FadeUp className="lg:col-span-7">
            <Quote size={48} className="text-saffron" strokeWidth={1} />
            <blockquote
              key={t.name}
              data-testid="testimonial-quote"
              className="mt-6 font-serif text-2xl md:text-3xl lg:text-4xl text-forest leading-[1.25] animate-[fade-up_0.8s_ease-out]"
            >
              “{t.quote}”
            </blockquote>
            <div className="mt-8 flex items-center gap-4">
              <img
                src={t.avatar}
                alt={t.name}
                className="w-14 h-14 rounded-full object-cover"
                loading="lazy"
              />
              <div>
                <p className="font-semibold text-forest">{t.name}</p>
                <p className="text-sm text-muted-ink">{t.role}</p>
              </div>
            </div>
          </FadeUp>

          <div className="lg:col-span-5 space-y-3">
            {TESTIMONIALS.map((item, idx) => (
              <button
                key={item.name}
                onClick={() => setI(idx)}
                data-testid={`testimonial-select-${idx}`}
                className={`w-full text-left p-5 transition-all border ${
                  idx === i
                    ? "bg-cream border-forest"
                    : "bg-transparent border-border-soft hover:bg-cream/60"
                }`}
              >
                <div className="flex items-center gap-4">
                  <img src={item.avatar} alt={item.name} className="w-12 h-12 rounded-full object-cover" loading="lazy" />
                  <div>
                    <p className="font-semibold text-forest">{item.name}</p>
                    <p className="text-xs text-muted-ink">{item.role}</p>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
